import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";

/*
|--------------------------------------------------------------------------
| GET PLANS
|--------------------------------------------------------------------------
| EN - Fetches the list of subscription plans.
| ES - Obtiene la lista de planes de suscripción.
*/
export async function getPlans() {
    try {
        const response = await api.get(CompanyRoutes.Subscriptions.Plans.getAll);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


/*
|--------------------------------------------------------------------------
| CREATE PLAN
|--------------------------------------------------------------------------
| EN - Sends the new plan data to the API.
| ES - Envía los datos del nuevo plan a la API.
*/
export async function createPlan(data) {
    try {
        const response = await api.post(CompanyRoutes.Subscriptions.Plans.create, data);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


/*
|--------------------------------------------------------------------------
| GET PLAN BY ID
|--------------------------------------------------------------------------
| EN - Fetches a single plan details.
| ES - Obtiene los detalles de un plan específico.
*/
export async function getPlan(id) {
    try {
        const url = CompanyRoutes.Subscriptions.Plans.show(id);
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}

/*
|--------------------------------------------------------------------------
| UPDATE PLAN
|--------------------------------------------------------------------------
| EN - Updates an existing plan.
| ES - Actualiza un plan existente.
*/
export async function updatePlan(id, data) {
    try {
        const url = CompanyRoutes.Subscriptions.Plans.update(id);
        // Usamos PUT para actualizar
        const response = await api.put(url, data); 
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


/*
|--------------------------------------------------------------------------
| DELETE PLAN
|--------------------------------------------------------------------------
| EN - Deletes a subscription plan.
| ES - Elimina un plan de suscripción.
*/
export async function deletePlan(id) {
    try {
        const url = CompanyRoutes.Subscriptions.Plans.delete(id);
        const response = await api.delete(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}